module.exports = __webpack_public_path__ + "img/corner_talk.79e77d45.gif";